import { SVGProps, Ref, forwardRef } from 'react'
const SvgVoice = (props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
  <svg
    width="1.5rem"
    height="1.5rem"
    fill="none"
    viewBox="0 0 24 24"
    xmlns="http://www.w3.org/2000/svg"
    ref={ref}
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="M1 21c0-2.761 2.239-5 5-5h5c2.761 0 5 2.239 5 5M20.33 4.415a4.85 4.85 0 0 1 0 6.858M17.108 6.13a2.425 2.425 0 0 1 0 3.43"
    />
    <circle
      cx={9}
      cy={8}
      r={4}
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
    />
  </svg>
)
const ForwardRef = forwardRef(SvgVoice)
export default ForwardRef
